import { render, staticRenderFns } from "./EditStockMovementComponent.vue?vue&type=template&id=92936b8e"
import script from "./EditStockMovementComponent.vue?vue&type=script&lang=js"
export * from "./EditStockMovementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports